import * as actions from '../pureActions/alertsActions';

export const showAlert =
  ({ type, message }) =>
  (dispatch) =>
    dispatch(actions.showAlert({ type, message }));
